<template>
  <div class="star-input">
    <div
      class="star-input--star star-input--star-1"
      v-on:mouseover="mouseOver(1)"
      v-on:mouseleave="mouseLeave"
      v-on:click="starClick(1)"
    >
      <StarIcon/>
    </div>

    <div
      class="star-input--star star-input--star-2"
      v-on:mouseover="mouseOver(2)"
      v-on:mouseleave="mouseLeave"
      v-on:click="starClick(2)"
    >
      <StarIcon/>
    </div>

    <div
      class="star-input--star"
      v-on:mouseover="mouseOver(3)"
      v-on:mouseleave="mouseLeave"
      v-on:click="starClick(3)"
    >
      <StarIcon/>
    </div>

    <div
      class="star-input--star star-input--star-4"
      v-on:mouseover="mouseOver(4)"
      v-on:mouseleave="mouseLeave"
      v-on:click="starClick(4)"
    >
      <StarIcon/>
    </div>

    <div
      class="star-input--star star-input--star-5"
      v-on:mouseover="mouseOver(5)"
      v-on:mouseleave="mouseLeave"
      v-on:click="starClick(5)"
    >
      <StarIcon/>
    </div>
  </div>
</template>

<script>
  import StarIcon from '../../icons/star.vue';

  export default {
    name: 'StarInput',
    props: [
      'number'
    ],
    components: {
      StarIcon
    },
    methods: {
      setStars: function() {
        // const stars = this.$el.querySelectorAll('.star-input--star');

        // if (this.number !== 0) {
        //   for (const [index, item] of stars.entries()) {
        //     item.querySelector('svg path').style.opacity = '1';

        //     if (index === this.number - 1) {
        //       return
        //     }
        //   }
        // }
      },
      mouseOver: function(currentNumber) {
        // const stars = this.$el.querySelectorAll('.star-input--star');

        // this.hoverNumber = currentNumber;

        // for (const [index, item] of stars.entries()) {
        //   item.querySelector('svg path').style.opacity = '1';

        //   if (index > currentNumber - 1) {
        //     item.querySelector('svg path').style.opacity = '0.5';
        //   }
        // }
      },
      mouseLeave: function() {
        // const stars = this.$el.querySelectorAll('.star-input--star');

        // this.hoverNumber = this.number;

        // for (const [index, item] of stars.entries()) {
        //   item.querySelector('svg path').style.opacity = '0.5';
        // }

        // this.setStars();
      },
      starClick: function(currentNumber) {
        // this.number = currentNumber;
        // this.setStars();
      }
    },
    mounted() {
      this.setStars();
    }
  }
</script>

<style lang="scss">
  .star-input {
    margin-bottom: 15px;

    &--star {
      display: inline-block;
      margin-right: 5px;
      // cursor: pointer;

      &:last-child {
        margin-right: 0;
      }

      svg {
        
        path {
          fill: var(--blue);
          // opacity: 0.5;
          transition: 0.2s;
        }
      }
    }
  }
</style>